import { Locale } from "@omni/types/enums/locale.enum";
import { DeepPartial } from "@omni/types/utils/deepPartial";
import { ModelMapper } from "@omni/types/utils/modelMapper";
import { getLocale } from "@omni/utils/locale.utils";
import { values } from "@omni/utils/object.utils";
import * as yup from "yup";

export type RawLanguage = {
    "url": string;
    "language": string;
    "language-name": string;
    "locale": string;
};

export const toLanguage: ModelMapper<
    DeepPartial<RawLanguage | undefined>,
    DeepPartial<Language>
> = (language) => {
    return {
        "url": language?.url,
        "locale": getLocale(language?.locale ?? ""),
        "language-code": language?.language,
        "language-name": language?.["language-name"]
    };
};

export const LanguageSchema = yup.object().shape({
    "url": yup.string().required(),
    "language-name": yup.string().required(),
    "language-code": yup.string().required(),
    "locale": yup.mixed<Locale>().oneOf(values(Locale)).required()
});

export type Language = yup.InferType<typeof LanguageSchema>;
